var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramInstalments64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fc0;}.cls-1,.cls-2,.cls-3{stroke:#4f4c4d;stroke-miterlimit:10;stroke-width:2px;}.cls-2,.cls-3{fill:none;}.cls-3{stroke-linecap:round;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.47,32.14A25.5,25.5,0,0,0,32,6.64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.47,32.14A25.5,25.5,0,0,0,32,6.64v7a18.52,18.52,0,0,1,18.5,18.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.47,32.14A25.5,25.5,0,0,1,32,6.64"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.47,32.14A25.5,25.5,0,0,1,32,6.64v7a18.52,18.52,0,0,0-18.5,18.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.47,32.14A25.5,25.5,0,0,1,32,57.64"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.47,32.14A25.5,25.5,0,0,1,32,57.64v-7a18.52,18.52,0,0,0,18.5-18.5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.47,32.14A25.49,25.49,0,0,0,32,57.64"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.47,32.14A25.49,25.49,0,0,0,32,57.64v-7a18.52,18.52,0,0,1-18.5-18.5Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.77,
    y: 25.65,
    width: 14.51,
    height: 14.51
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.89,28.56V24.35A3.15,3.15,0,0,1,32,21.21h0a3.15,3.15,0,0,1,3.14,3.14v4.21"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramInstalments64);
export default __webpack_public_path__ + "static/media/pictogramInstalments64.063a57e97fcd9678009732e8ebaf9b4c.svg";
export { ForwardRef as ReactComponent };